import React from 'react'

import { type CrossClientQueryResultCellProps } from './types'
import { useAppSelector } from '../../../../store/hooks'
import { selectCrossClientActionsByClientId } from '../../../../store/crossClient/crossClientActions'
import { selectCrossClientClients } from '../../../../store/crossClient/crossClientResults'
import { getUserDisplayName } from '../../../../apps/professional-app/fa/common/aifeatures/utils'
import { CrossClientActionGroupButton } from './CrossClientActionGroupButton'

export const CrossClientQueryResultActionsCell: React.FC<CrossClientQueryResultCellProps> = ({ result }) => {
  const actionsByClientId = useAppSelector(selectCrossClientActionsByClientId)
  const clients = useAppSelector(selectCrossClientClients)
  const actions = actionsByClientId[result.clientId] ?? []

  if (!actions.length) {
    return null
  }

  const clientName = getUserDisplayName(clients[result.clientId])

  return (
    <div className='zocks-py-0.75 flex-1 d-flex align-items-center gap-2'>
      <CrossClientActionGroupButton actions={actions} clientId={result.clientId} clientName={clientName} />
    </div>
  )
}
